import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from 'src/app/services/api.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-startup-list',
  templateUrl: './startup-list.component.html',
  styleUrls: ['./startup-list.component.css'],
})
export class StartupListComponent implements OnInit {
  displayedColumns: string[] = [
    'index',
    'incubatorName',
    'startupName',
    'incubatorEmail',
    'incubatorPhone',
  ];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  private listApi = environment.url + environment.startupsList;
  /**
   * The constructor for the StartupListComponent.
   * @param makeapi The API service provider.
   * @param getdata The Value service provider.
   * @param dialog The Material dialog service provider.
   */
  constructor(
    private makeapi: ApiService,
    private getdata: ValueService,
    public dialog: MatDialog
  ) {
    /**
     * Initialize the MatTableDataSource with empty data.
     */
    this.dataSource = new MatTableDataSource();
  }

  roleValue;
  /**
   * Initializes the component by setting the visibility of a loading indicator,
   * retrieving the user's role, and fetching the list of startups.
   */
  ngOnInit(): void {
    // Show the loading indicator
    this.getdata.isVisibleSource.next(true);

    // Retrieve the user's role from session storage
    this.roleValue = sessionStorage.getItem('role');

    // Fetch the list of startups
    this.ListApi();
  }
  list = {};
  disList: any = [];
  pageTotalCount: number;
  pageSize: number = 10;
  pageNumber: number = 1;
  noData = true;
  /**
   * Fetches the list of startups from the API based on the pagination.
   * Subscribes to the API response and updates the component data.
   * @returns An observable containing the response from the API
   */
  ListApi() {
    // Create the API request parameters
    const params = `${this.listApi}?listSize=${this.pageSize}&pageNumber=${this.pageNumber}`;
    // Call the API to fetch the list of startups
    return this.makeapi.method(params, this.list, 'get').subscribe((data) => {
      // Check if there is no data returned
      if (data.count == 0) {
        // Set the noData flag to true if there is no data
        this.noData = true;
      } else {
        // Set the noData flag to false if there is data
        this.noData = false;
        // Set the total count of items
        this.pageTotalCount = data.count;
        // Update the list of startups
        this.disList = data.approvalPendingUsers;
        // Update the MatTableDataSource with the new data
        this.dataSource = new MatTableDataSource(data.approvalPendingUsers);
      }
    });
  }
  /**
   * Called after the component's view has been fully initialized.
   * Sets the paginator for the MatTableDataSource.
   */
  ngAfterViewInit() {
    // Set the paginator for the MatTableDataSource
    this.dataSource.paginator = this.paginator;
  }

  /**
   * Gets the data from the API based on the pagination event.
   * Updates the list of startups based on the new pagination data.
   * @param event The pagination event from the Material table
   */
  getServerData(event) {
    // Update the page number and page size
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    // Create the request parameters
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
    };
    // Call the API to get the updated data
    this.ListApi();
  }
}
